import { Serializable } from '../interfaces';
import DetallesCupsMulticau, { DetallesCupsMulticauAPI } from './detallesCupsMulticau';

export interface CupsInfoAPI {
  cups: string;
  nombre: string;
  apellidos: string;
  domicilio: string;
  poblacion: string;
  provincia: string;
  codigoPostal: string;
  telefono: string;
  esComunidad: string;
  esFotovoltaica: 'si' | 'no';
  modem: 'si' | 'no';
  esTarifaIndexada: 'si' | 'no';
  esClienteECE: 'si' | 'no';
  esClienteElecsum: 'si' | 'no';
  nif: string;
  detallesCupsMulticau?: DetallesCupsMulticauAPI[];
}

export default class CupsInfo implements Serializable<CupsInfo> {
  cups: string;

  nombre: string;

  apellidos: string;

  domicilio: string;

  poblacion: string;

  provincia: string;

  codigoPostal: string;

  telefono: string;

  esComunidad: string;

  fotovoltaica: string;

  modem: boolean;

  esTarifaIndexada: string;

  esClienteECE: boolean;

  esClienteElecsum: boolean;

  autorizados: string;

  propietario: string;

  nif: string;

  detallesCupsMulticau: DetallesCupsMulticau[];

  isComunity(): boolean {
    return this.esComunidad === 'si';
  }

  deserialize(input: CupsInfoAPI): CupsInfo {
    if (!input) {
      return this;
    }

    this.cups = input.cups || '';
    this.nombre = input.nombre || '';
    this.apellidos = input.apellidos || '';
    this.domicilio = input.domicilio || '';
    this.poblacion = input.poblacion || '';
    this.provincia = input.provincia || '';
    this.codigoPostal = input.codigoPostal || '';
    this.telefono = input.telefono || '';
    this.esComunidad = input.esComunidad || '';
    this.fotovoltaica = input.esFotovoltaica || 'no';
    this.modem = input.modem === 'si';
    this.esTarifaIndexada = input.esTarifaIndexada || 'no';
    this.esClienteECE = input.esClienteECE === 'si';
    this.esClienteElecsum = input.esClienteElecsum === 'si';
    this.nif = input.nif || '';
    this.detallesCupsMulticau = (input.detallesCupsMulticau || []).map(
      (detalle) => new DetallesCupsMulticau(detalle),
    );

    return this;
  }

  deserializeArray(inputArray: Array<CupsInfoAPI>): Array<CupsInfo> {
    const cups: Array<CupsInfo> = inputArray.map((input) => new CupsInfo().deserialize(input));

    return cups;
  }
}
